module.exports = __webpack_public_path__ + "static/media/8.d2a99df1.avif";